'use client';

import { useParams, useRouter, usePathname } from 'next/navigation';
import { CountrySelector } from 'ui/components/CountrySelector/CountrySelector';
import type { CountrySelection } from 'ui/types/CountrySelectorTypes';
// import type { CountryCode } from '@whoop/i18n/types/address';
// import type { Language } from '@whoop/i18n';
import { useTranslation } from '@whoop/i18n/lang/client';
import { getCountrySelectorRegions } from 'ui/utils/countrySelectorHelper';
import { getSupportedCountriesAndLanguagesByRegion } from '@whoop/i18n/utils/countrySelectorHelpers';
import { useState } from 'react';
import { useNavigation } from '@/hooks/useNavigation';

export const CountrySelectorWrapper = () => {
  const regions = getCountrySelectorRegions(
    getSupportedCountriesAndLanguagesByRegion(),
  );

  const { language, ...params } = useParams();
  let { country } = params;
  country = typeof country === 'string' ? country.toUpperCase() : '';
  const [showCountrySelector, setShowCountrySelector] = useState(false);
  const { changeSiteCountryAndLanguage } = useNavigation();

  // TODO: 'language' parameter can be removed later if, for example, langauge
  // can be added elsewhere to the html tag
  // @ts-expect-error rgument of type 'string | string[]' is not assignable to parameter of type '"en" | "de" | "fr" | "es" | "it" | "pt" | undefined'.
  const { t } = useTranslation('countrySelector', language);

  const handleSelection = (newSelection: CountrySelection) => {
    changeSiteCountryAndLanguage(newSelection);
    // @TODO: maybe track event here
  };

  return (
    <CountrySelector
      changeLanguageText={t('Change Language')}
      countrySelectorTitle={t('Choose Your Country')} // TODO: Missing translation
      languageSelectorTitle={t('Choose Your Language')}
      onSelect={handleSelection}
      onToggle={() => setShowCountrySelector((prev) => !prev)}
      // @ts-expect-errorType 'string | string[]' is not assignable to type '"en" | "de" | "fr" | "es" | "it" | "pt"'.
      previousSelection={{ countryCode: country, languageCode: language }}
      regions={regions}
      showCountrySelector={showCountrySelector}
      setShowCountrySelector={setShowCountrySelector}
    />
  );
};
